import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import {Link} from 'react-router-dom';
import lang from '../../constants/Languages.js';

//img
import logo from '../../assets/icons/logo.svg';
import logoAccent from '../../assets/icons/logo-accent.svg';
import logoDark from '../../assets/icons/logo-dark.svg';

const HeaderLogo = ({ clang }) => {
    return (
        <div className="header__logo">
            <Link to={`/`} className="header__logo-img__link" title={lang[clang].title.home}>
                <img className="header__logo-img" src={logo} alt={lang[clang].alt.logo} />
                <img className="header__logo-img hover" src={logoAccent} alt={lang[clang].alt.logo} />
                <img className="header__logo-img contrast" src={logoDark} alt={lang[clang].alt.logo} />
            </Link>
        </div>
    );
};

HeaderLogo.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeaderLogo);



// WEBPACK FOOTER //
// ./src/components/header/HeaderLogo.js